import selfMsgBox from './src/main.js'
window._selfMsgBox = selfMsgBox
export default selfMsgBox


// WEBPACK FOOTER //
// ./src/components/selfMsgBox/index.js